import { jsPDF } from "jspdf";

async function loadLogoDataUrl() {
  try {
    const res = await fetch("/logo.png");
    const blob = await res.blob();
    return await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}

export async function downloadCertificate(cert) {
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();

  // Amber brand colour
  const AMBER = [224, 90, 16];

  doc.setFillColor(255, 253, 249);
  doc.rect(0, 0, w, h, "F");

  doc.setDrawColor(...AMBER);
  doc.setLineWidth(6);
  doc.rect(24, 24, w - 48, h - 48);
  doc.setDrawColor(203, 213, 225);
  doc.setLineWidth(1);
  doc.rect(36, 36, w - 72, h - 72);

  // Logo (centered near the top)
  const logo = await loadLogoDataUrl();
  if (logo) {
    try {
      doc.addImage(logo, "PNG", w / 2 - 26, 58, 52, 52);
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.error("Certificate logo could not be embedded:", err);
    }
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(...AMBER);
  doc.text("CLASSROOM TO CORPORATE", w / 2, 132, { align: "center" });

  doc.setFontSize(34);
  doc.setTextColor(15, 23, 42);
  doc.text("Certificate of Completion", w / 2, 178, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);
  doc.setTextColor(100, 116, 139);
  doc.text("This certifies that", w / 2, 222, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(30);
  doc.setTextColor(...AMBER);
  doc.text(cert.user_name || "Student", w / 2, 265, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);
  doc.setTextColor(100, 116, 139);
  doc.text("has successfully completed the course", w / 2, 302, { align: "center" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(15, 23, 42);
  doc.text(cert.course_title, w / 2, 336, { align: "center" });

  const date = new Date(cert.issued_at).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(100, 116, 139);
  doc.text(`Issued ${date}`, w / 2, 372, { align: "center" });
  if (cert.instructor) doc.text(`Instructor: ${cert.instructor}`, w / 2, 392, { align: "center" });

  // Credit + certificate id footer
  doc.setFontSize(10);
  doc.setTextColor(71, 85, 105);
  doc.text("Prepared by & all rights reserved to Darshan Thakkar", w / 2, h - 66, { align: "center" });

  doc.setFontSize(9);
  doc.setTextColor(148, 163, 184);
  doc.text(`Certificate ID: ${cert.cert_id}`, w / 2, h - 50, { align: "center" });

  const safe = (cert.course_title || "certificate").replace(/[^a-z0-9]/gi, "_");
  doc.save(`${safe}_certificate.pdf`);
}
